/*考试*/
const Index = () => import(/* webpackChunkName: "group-exam" */ '../view/exam/Index.vue');
const Answer = () => import(/* webpackChunkName: "group-exam" */ '../view/exam/Answer.vue');
const Result = () => import(/* webpackChunkName: "group-exam" */ '../view/exam/Result.vue');

export default [
    {
        path: '/exam',
        name: 'exam',
        component: Index,
        meta: {
            title: '【旋涡营销】网络营销考试系统，助力企业人才初步筛选',
            keywords: '网络营销人才考核，网络营销人才筛选，营销人才面试',
            description: '旋涡营销考试系统是一款提升网络营销运营人才能力，协助企业进行网络运营人才面试的初步筛选，帮助企业招到想要的网络运营人才'
        }
    },
    {
        path: '/exam-answer',
        name: 'exam-answer',
        component: Answer,
        meta: {
            title: '【旋涡营销】网络营销考试系统，助力企业人才初步筛选'
        }
    },
    {
        path: '/exam-result',
        name: 'exam-result',
        component: Result,
        meta: {
            title: '【旋涡营销】网络营销考试系统，助力企业人才初步筛选'
        }
    }
]



// WEBPACK FOOTER //
// ./app/router/router-exam.js